module.exports = __webpack_public_path__ + "8355721056a23d0c67017c89a01ea676.fbx";